import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';

export const QUESTION_GROKKED = {
  YES: 1,
  NO: -1,
  NO_RESPONSE: 0,
};

export const STATUS = {
  UNINITIALIZED: 'edrolo/exams/UNINITIALIZED',
  LOADING: 'edrolo/exams/LOADING',
  READY: 'edrolo/exams/READY',
  FAILURE: 'edrolo/exams/FAILURE',
  RELOADING: 'edrolo/exams/RELOADING',
};

export const SAVING_STATUS = {
  IDLE: 'IDLE',
  SAVING: 'SAVING',
  SAVED: 'SAVED',
  ERROR: 'ERROR',
};

export const QUESTION_GROKKED_LABEL = {
  UNDERSTANDS: 'Understands',
  NEEDS_HELP: 'Needs help',
  NOT_REFLECTED: 'Not reflected',
};

export const EXAM_ANALYTICS_CONSTANTS = {
  ORIGIN: {
    EXAMS: 'exams',
    QUESTION_SET: 'Question Set',
  },
  PAGES: {
    QUESTION_SET_RESULTS_GRID: 'Question Set Results Grid',
  },
  EVENTS: {
    CLICKED_LINK_TO_STUDENT_COURSE_PROGRESS:
      'clicked link to student course progress',
    CLICKED_QUESTION_INFORMATION_MODAL_VIEW_STUDENT_RESPONSES_BUTTON:
      'clicked question information modal view student responses button',
    CLICKED_QUESTION_GRID_STUDENT_RESPONSE:
      'clicked question grid student response',

    CLOSED_QUESTION_INFORMATION_MODAL: 'closed question information modal',
    OPENED_QUESTION_INFORMATION_MODAL: 'opened question information modal',
  },
};

export const SPICINESS_LEVEL = {
  1: 'Mild',
  2: 'Medium',
  3: 'Spicy',
};

export const WORKING_PATHWAYS = {
  1: 'Mild path',
  2: 'Medium path',
  3: 'Spicy path',
};

export const ENABLED_WORKING_PATHWAYS_FILTER_COURSE_IDS = [
  51547, 51632, 51718, 51842, 50944, 51059,
];

export const SELF_MARKABLE_QUESTION_TYPES = [
  EXAM_QUESTION_TYPES.ILLUSTRATION,
  EXAM_QUESTION_TYPES.TEXT,
  EXAM_QUESTION_TYPES.TEXT_CHECKLIST,
  EXAM_QUESTION_TYPES.WORKED,
  EXAM_QUESTION_TYPES.WORKED_ANNOTATED_IMAGE,
  EXAM_QUESTION_TYPES.COMPLEX, // TODO: deprecate
];
